module.exports = __webpack_public_path__ + "static/media/empty_feed.08138cd4.svg";